export const POST_ORG_USER = "post_org_user";
export const POST_ORG_USER_SUCCESSFUL = "post_org_user_successful";
export const POST_ORG_USER_FAILED = "post_org_user_failed";

export const PUT_ORG_USER = "put_org_user";
export const PUT_ORG_USER_SUCCESSFUL = "put_org_user_successful";
export const PUT_ORG_USER_FAILED = "put_org_user_failed";

export const DELETE_ORGANIZATION_USER = "delete_organization_user";
export const DELETE_ORGANIZATION_USER_SUCCESSFUL = "delete_organization_user_successful";
export const DELETE_ORGANIZATION_USER_FAILED = "delete_organization_user_failed";

export const CLEAR_ALL_ORG_USER_MESSAGES = "clear_all_org_user_messages";
export const CLEAR_ALL_ORG_USER_MESSAGES_SUCCESSFUL = "clear_all_org_user_messages_successful";